export * from './terroristFilter.component';